import React from "react"
import LOGO from 'images/logo/logo-horizontal-white.png'
import Theme from './logo.module.scss'

const Image = () => (
  <img src={LOGO} className={Theme.Logo} />
)
export default Image
